import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { DynamicComponentManifest } from './dynamic-component-loader.types';

export const DYNAMIC_COMPONENT_MANIFESTS = new InjectionToken<DynamicComponentManifest>(
    'DynamicComponentManifest',
);

@NgModule()
export class DynamicComponentLoaderModule {
  static forRoot(manifests: DynamicComponentManifest[]): ModuleWithProviders<DynamicComponentLoaderModule> {
    return {
      ngModule: DynamicComponentLoaderModule,
      providers: [
        {
          provide: DYNAMIC_COMPONENT_MANIFESTS,
          useValue: manifests,
        },
      ],
    };
  }
}
